var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 26,
    viewBox: "0 0 8 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99773 6.58139C5.53899 6.58139 6.78842 5.33195 6.78842 3.7907C6.78842 2.24944 5.53899 1 3.99773 1C2.45647 1 1.20703 2.24944 1.20703 3.7907C1.20703 5.33195 2.45647 6.58139 3.99773 6.58139Z",
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99773 15.5121C5.53899 15.5121 6.78842 14.2626 6.78842 12.7214C6.78842 11.1801 5.53899 9.93066 3.99773 9.93066C2.45647 9.93066 1.20703 11.1801 1.20703 12.7214C1.20703 14.2626 2.45647 15.5121 3.99773 15.5121Z",
    fill: "white",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99773 25.0003C5.53899 25.0003 6.78842 23.7509 6.78842 22.2096C6.78842 20.6684 5.53899 19.4189 3.99773 19.4189C2.45647 19.4189 1.20703 20.6684 1.20703 22.2096C1.20703 23.7509 2.45647 25.0003 3.99773 25.0003Z",
    fill: "white",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.971aa4759641d8c10e5d251bfb43ad5a.svg";
export { ForwardRef as ReactComponent };